import { Drafts } from '@mui/icons-material';
import { useCallback } from 'react';
import {
  Button,
  useListContext,
  useNotify,
  useRecordContext,
  useRefresh,
  useResourceContext,
  useUnselectAll,
  useUpdateMany
} from 'react-admin';

function MarkAsUnreadedButton(): JSX.Element {
  const refresh = useRefresh();
  const notify = useNotify();
  const resource = useResourceContext();
  const unselectAll = useUnselectAll(resource);
  const { selectedIds, data: tableRows } = useListContext();
  const record = useRecordContext();
  const rows = selectedIds.map((id) => tableRows.find((d) => d.id === id)).concat([record]);
  const [updateMany, { isLoading }] = useUpdateMany(
    resource,
    {
      ids: selectedIds.length > 0 ? selectedIds : [record?.id],
      data: { readed: null },
      // @ts-ignore
      rows
    },
    {
      onSuccess: () => {
        refresh();
        notify('resources.notifications.messages.unreaded.done');
        unselectAll();
      },
      onFailure: () => notify('resources.notifications.messages.unreaded.error', { type: 'warning' })
    }
  );

  const handleUpdateMany = useCallback(() => {
    updateMany();
  }, [updateMany]);

  return (
    <Button
      color="secondary"
      label="ra.notification.mark_as_unreaded"
      disabled={isLoading || (record && !record?.readed)}
      onClick={handleUpdateMany}
    >
      <Drafts />
    </Button>
  );
}

export { MarkAsUnreadedButton };
